__turbopack_context__.v({
  "className": "lato_89179c10-module__GFhOea__className",
  "variable": "lato_89179c10-module__GFhOea__variable",
});
